// Asset version for cache‑busting
// Increment this value (e.g., date or build number) whenever assets change
export const assetVersion = "20260120v4";

export const withVersion = (path) => `${path}?v=${assetVersion}`;
